import React, { createContext, useContext, useState, useCallback } from 'react';

export interface DriversAvailability {
  bike: number;
  motorcycle: number;
  car: number;
  van: number;
}

interface DriversAvailabilityContextType {
  availability: DriversAvailability;
  setAvailability: (availability: DriversAvailability) => void;
}

const DriversAvailabilityContext = createContext<DriversAvailabilityContextType | undefined>(undefined);

export const useDriversAvailability = () => {
  const context = useContext(DriversAvailabilityContext);
  if (!context) {
    throw new Error('useDriversAvailability must be used within DriversAvailabilityProvider');
  }
  return context;
};

export const DriversAvailabilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [availability, setAvailability] = useState<DriversAvailability>({
    bike: 0,
    motorcycle: 0,
    car: 0,
    van: 0,
  });

  return (
    <DriversAvailabilityContext.Provider value={{ availability, setAvailability }}>
      {children}
    </DriversAvailabilityContext.Provider>
  );
};
